import { useEffect } from "react";
import "./day-zero-focus.css";

/**
 * Holds the member's attention on the one Day Zero card that is speaking.
 *
 * Two shapes, because the card lives in two places. Off Today the handoff is a
 * fixed toast, so a scrim under it dims and blocks the page beneath. On Today
 * the card sits inside the grid, where a scrim cannot reliably cover its
 * siblings without fighting the stacking contexts the reveal animations
 * create, so the siblings dim themselves instead via a body flag.
 */
export function DayZeroFocus({ active, scrim }: { active: boolean; scrim: boolean }) {
  useEffect(() => {
    if (!active) return;
    document.body.setAttribute("data-dayzero-focus", "true");
    return () => {
      document.body.removeAttribute("data-dayzero-focus");
    };
  }, [active]);

  if (!active || !scrim) return null;
  // Inert to assistive tech: the toast above it is the thing to read.
  return <div className="dayzero-scrim" aria-hidden="true" />;
}
